import { render, staticRenderFns } from "./ProductRecommendation.vue?vue&type=template&id=ee19e5ae&"
import script from "./ProductRecommendation.vue?vue&type=script&lang=js&"
export * from "./ProductRecommendation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports